module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_top_custom_data-39dd0874006e03be7ce0a8638ef5a10d.png";